import { ParsedQs } from 'qs';
import { useLocation } from 'react-router-dom';
import { getSearchParams } from 'src/utils/url';

export function useQuery(): ParsedQs;
export function useQuery(x: string): string | null;
export function useQuery(x: string[]): (string | null)[];

export function useQuery(param?: string | string[]) {
  // rerender the component when search changes
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { search } = useLocation();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return getSearchParams(param);
}
